import { Outlet } from 'react-router-dom';

/**
 * App shell minimal — chaque route gère ses propres redirections via les
 * <SignedIn> / <SignedOut> de Clerk + le AppLayout.
 */
export default function App() {
  return <Outlet />;
}
